module.exports = __webpack_public_path__ + "img/m-jian-z-3-0.22ba8622.png";